<template>
  <!-- {{ $stores?.appData?.state?.data }} -->
  <div class="p-6 md:p-8">
    <div class="max-w-4xl mx-auto">
      <!-- profile header -->
      <div class="flex flex-col items-center">
        <div class="">
          <div class="relative top-0 left-0 w-[25vw] md:w-32 md:h-32 h-[25vw]">
            <ImgComponent
              :src="$stores.user?.state?.current?.email"
              avatar
              alt="Profile"
              class="w-full h-full rounded-full bg-primary-50"
            />
            <div
              class="absolute -bottom-2 right-0 w-8 h-8 bg-green-500 rounded-full border-4 border-secondary flex items-center justify-center"
            >
              <svg
                class="w-4 h-4 text-white"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                ></path>
              </svg>
            </div>
          </div>
        </div>
        <div class="text-center overflow-hidden w-full mt-4">
          <h2
            class="text-2xl md:text-3xl title-color mb-1 font-bold truncate w-full"
          >
            {{ $stores.user?.state?.current?.firstName }}
            {{ $stores.user?.state?.current?.lastName }}
          </h2>
          <p class="description-color mb-1 text-sm md:text-base">
            {{ $stores.user?.state?.current?.email }}
          </p>
        </div>
        <p
          class="description-color mb-1 rounded-full border border-primary-200 px-5 py-1 text-sm md:text-base"
        >
          {{
            Countries.find($stores.user?.state?.current?.countryCode)
              ?.countryName
          }}
        </p>
      </div>
    </div>
  </div>

  <!-- main content -->
  <div class="-mt-4 rounded-t-3xl p-6 md:p-8 relative">
    <div class="max-w-4xl mx-auto">
      <!-- settings button -->
      <div
        class="cursor-pointer rounded-3xl bg-gray-500/5 p-3 md:p-4"
        v-bus:EVENTS.BOOKMAKER.SELECT_BOOKMAKER_ID_TO_CHANGE.click
      >
        <div class="flex items-center gap-4">
          <div
            class="w-12 h-12 rounded-full bg-white flex items-center justify-center"
          >
            <ColorImg
              src="/images/profile/setting.svg"
              class="w-6 h-6 bg-gray-800"
            />
          </div>
          <div>
            <p class="text-gray-500 text-sm font-bold">Changer mes IDs</p>
            <p class="title-color font-bold">Configurer</p>
          </div>
          <svg
            class="w-5 h-5 text-gray-400 group-hover:text-gray-600 transition-colors ml-auto mr-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 5l7 7-7 7"
            ></path>
          </svg>
        </div>
      </div>

      <!-- contact section -->
      <h3 class="text-xl title-color mb-4 mt-8 font-bold">Pour plus d'infos</h3>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <a
          v-for="(content, i) in contactContents"
          :key="i"
          :href="
            (content.id == 'email' ? 'mailto:' : '') +
            ($stores.appData?.state?.data?.general?.[content.id] || '')
          "
          target="_blank"
          class="flex items-center gap-3 rounded-3xl bg-gray-500/5 p-3 md:p-4 hover:bg-gray-500/10 transition-colors"
        >
          <div
            class="w-10 h-10 md:w-12 md:h-12 rounded-lg flex items-center justify-center transition-colors"
          >
            <ColorImg
              :src="content.icon"
              class="w-5 h-5 md:w-6 md:h-6 bg-gray-800"
            />
          </div>
          <div class="flex-1">
            <p class="title-color font-bold">{{ content.name }}</p>
            <p class="text-gray-500 text-sm">{{ content.actionText }}</p>
          </div>
          <svg
            class="w-5 h-5 text-gray-400 transition-colors"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 5l7 7-7 7"
            ></path>
          </svg>
        </a>
      </div>

      <!-- quick help section -->
      <div class="mt-8">
        <h3 class="text-xl title-color mb-4 mt-8 font-bold">Aide rapide</h3>
        <div class="space-y-3">
          <div
            v-for="(content, i) in helpContents"
            :key="i"
            @click="
              () => {
                if (content.id == 'rechargeHelp') rechargeHelpClick();
                if (content.id == 'withdrawHelp') withdrawHelpClick();
                if (content.id == 'iphoneInstallationHelp')
                  iphoneInstallationHelpClick();
              }
            "
            class="flex items-center gap-3 p-4 rounded-3xl bg-gray-500/5 cursor-pointer hover:bg-gray-500/10 transition-colors"
          >
            <ColorImg :src="content.icon" class="w-6 h-6 bg-gray-800" />
            <div class="flex-1">
              <p class="title-color font-bold">
                {{ content.name }}
              </p>
              <p class="text-gray-500 text-sm">
                {{ content.actionText }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- networks section -->
      <div class="mt-8">
        <h3 class="text-xl title-color mb-4 mt-8 font-bold">Suivez-nous</h3>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
          <a
            v-for="(content, i) in networksContents"
            :key="i"
            :href="$stores.appData?.state?.data?.general?.[content.id] || ''"
            target="_blank"
            class="flex items-center gap-3 p-4 rounded-3xl bg-gray-500/5 hover:bg-gray-500/10 transition-colors"
          >
            <ColorImg :src="content.icon" class="w-6 h-6 bg-gray-800" />
            <div class="flex-1">
              <p class="title-color font-bold">
                {{ content.name }}
              </p>
              <p class="text-gray-500 text-sm">
                {{ content.actionText }}
              </p>
            </div>
          </a>
        </div>
      </div>

      <!-- logout button -->
      <div class="text-center mt-8">
        <button
          @click="
            () => {
              $bus.emit($constants.EVENTS.USER.LOGOUT);
              $router.replace('/login');
            }
          "
          class="w-full justify-center md:justify-between inline-flex items-center gap-3 px-8 py-4 rounded-3xl font-bold bg-gray-500/5 hover:bg-gray-500/10 transition-colors"
        >
          Me déconnecter
          <ColorImg
            src="/images/profile/logout.svg"
            class="w-6 h-6 bg-current"
          />
        </button>
      </div>
    </div>
  </div>
  <div class="hidden">
    <a
      :href="requestedContentLink"
      ref="requestedContentLinkTag"
      target="_blank"
    ></a>
  </div>

  <div class="mobile-bottom-padding relative"></div>
</template>

<script>
import { defineComponent } from 'vue';
import { Countries } from '../../shared/libraries/countries';

export default defineComponent({
  name: 'ProfilePage',
  components: {},
  setup() {
    return { Countries };
  },
  data() {
    return {
      reducedBadges: true,
      moreHelpModalVisible: false,
      enableWhatsapNotf: false,
      userCountry: {},
      requestedContentLink: '',
      contactContents: [
        {
          id: 'whatsappAssistanceLink',
          name: 'Whatsapp',
          icon: '/images/profile/whatsapp.svg',
          actionText: 'Contacter'
        },
        {
          id: 'telegramAssistanceLink',
          name: 'Telegram',
          icon: '/images/profile/telegram.svg',
          actionText: 'Contacter'
        },
        {
          id: 'email',
          name: 'Email',
          icon: '/images/profile/email.svg',
          actionText: 'Envoyer'
        },
        {
          id: 'faqUrl',
          name: 'F.A.Q.',
          icon: '/images/profile/help.svg',
          actionText: 'Visiter'
        }
      ],
      networksContents: [
        {
          id: 'whatsappLink',
          name: 'Whatsapp',
          icon: '/images/profile/whatsapp.svg',
          actionText: 'Suivre'
        },
        {
          id: 'telegramLink',
          name: 'Telegram',
          icon: '/images/profile/telegram.svg',
          actionText: 'Suivre'
        },
        {
          id: 'instagramLink',
          name: 'Instagram',
          icon: '/images/profile/instagram_1.svg',
          actionText: 'Suivre'
        },
        {
          id: 'facebookLink',
          name: 'Facebook',
          icon: '/images/profile/facebook-app-symbol.svg',
          actionText: 'Suivre'
        },
        {
          id: 'tiktokLink',
          name: 'TikTok',
          icon: '/images/profile/tik-tok.svg',
          actionText: 'Suivre'
        },
        {
          id: 'websiteLink',
          name: 'Site Web',
          icon: '/images/profile/website.svg',
          actionText: 'Visiter'
        }
      ],
      helpContents: [
        {
          id: 'rechargeHelp',
          isLink: false,
          name: 'Comment faire un dépot ?',
          icon: '/images/profile/help.svg',
          actionText: 'Voir'
        },
        {
          id: 'withdrawHelp',
          isLink: false,
          name: 'Comment Faire un retrait ?',
          icon: '/images/profile/help.svg',
          actionText: 'Voir'
        },
        {
          id: 'iphoneInstallationHelp',
          isLink: false,
          name: 'Comment installer sur Iphone ?',
          icon: '/images/profile/help.svg',
          actionText: 'Voir'
        }
      ],
      appsContents: [
        {
          id: 'xbetDownloadUrl',
          isLink: true,
          name: 'Télécharger 1Xbet',
          icon: '/images/icons/1xBetIco.svg',
          actionText: 'Télécharger'
        },
        {
          id: 'betwinnerDownloadUrl',
          isLink: true,
          name: 'Télécharger Betwinner',
          icon: '/images/icons/betwinner.png',
          actionText: 'Télécharger'
        },
        {
          id: 'melbetDownloadUrl',
          isLink: true,
          name: 'Télécharger Melbet',
          icon: '/images/icons/melbetIcon.svg',
          actionText: 'Télécharger'
        },
        {
          id: 'eightStarzDownloadUrl',
          isLink: true,
          name: 'Télécharger 888Starz',
          icon: '/images/icons/eightStarz.png',
          actionText: 'Télécharger'
        },
        {
          id: 'oneWinDownloadUrl',
          isLink: true,
          name: 'Télécharger OneWin',
          icon: '/images/icons/1winIcon.svg',
          actionText: 'Télécharger'
        }
      ]
    };
  },
  mounted() {},
  methods: {
    async setAccountId() {
      const acocuntIdsPreferencesConfig = [
        {
          dataToSet: 'xbetAccountId',
          name: '1xBet'
        },
        {
          dataToSet: 'betwinnerAccountId',
          name: 'Betwinner'
        },
        {
          dataToSet: 'melbetAccountId',
          name: 'Melbet'
        },
        {
          dataToSet: 'eightStarzAccountId',
          name: '888Starz'
        },
        {
          dataToSet: 'oneWinAccountId',
          name: '1Win'
        }
      ];
      const prompt = await window.choicePrompt({
        title: 'Modifier votre identifiant',
        options: acocuntIdsPreferencesConfig,
        formatDisplay: (data) => data?.name || '',
        successText: 'Modifier'
      });
      if (!prompt.accepted || !prompt.data) return;
      this.$Events.dispatchEvent('preference_update_requested', prompt.data);
    },
    rechargeHelpClick() {
      this.requestContentDisplay(
        'Comment faire un dépot via 1BPay',
        'rechargeVideoLink',
        'rechargeTutorialLink'
      );
    },
    withdrawHelpClick() {
      this.requestContentDisplay(
        'Comment faire des retrait via 1BPay',
        'withdrawVideoLink',
        'withdrawTutorialLink'
      );
    },
    iphoneInstallationHelpClick() {
      const requestedContentLink =
        this.$stores.appData?.state?.data?.general?.[
          'iphoneInstallationVideoLink'
        ];
      if (!requestedContentLink)
        this.$bus.emit(this.$constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
          title: 'Contenu non disponible',
          body: "Ce contenu n'est pas disponible pour le moment"
        });
      else {
        this.requestedContentLink = requestedContentLink;
        setTimeout(() => {
          this.$refs.requestedContentLinkTag.click();
        }, 200);
      }
    },
    async requestContentDisplay(title, videoKey, tutoKey) {
      const contentToShow = await this.requestTypeOfHelpToShow(title);
      console.log('🚀 ~ contentToShow:', contentToShow);
      if (!contentToShow) return;
      let requestedContentLink = null;
      if (contentToShow == 'video')
        requestedContentLink =
          this.$stores.appData?.state?.data?.general?.[videoKey];
      if (contentToShow == 'tutorial')
        requestedContentLink =
          this.$stores.appData?.state?.data?.general?.[tutoKey];
      if (!requestedContentLink)
        this.$bus.emit(this.$constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
          title: 'Contenu non disponible',
          body: "Ce contenu n'est pas disponible pour le moment"
        });
      else {
        this.requestedContentLink = requestedContentLink;
        setTimeout(() => {
          this.$refs.requestedContentLinkTag.click();
        }, 200);
      }
    },
    async requestTypeOfHelpToShow(title) {
      const acocuntIdsPreferencesConfig = [
        {
          title: 'Guide documentaire',
          name: 'tutorial'
        },
        {
          title: 'Vidéo explicative',
          name: 'video'
        }
      ];
      const prompt = await window.choicePrompt({
        title: title,
        options: acocuntIdsPreferencesConfig,
        formatDisplay: (data) => data?.title || '',
        successText: 'Continuer'
      });
      if (!prompt.accepted || !prompt.data) return null;
      return prompt.data.name;
    }
  }
});
</script>
